import { render, staticRenderFns } from "./NotificationCardActivityPanel.vue?vue&type=template&id=d6a364b4&scoped=true&"
import script from "./NotificationCardActivityPanel.vue?vue&type=script&lang=js&"
export * from "./NotificationCardActivityPanel.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCardActivityPanel.vue?vue&type=style&index=0&id=d6a364b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a364b4",
  null
  
)

export default component.exports